import { isEmpty, isEqual, xorWith } from 'lodash';

export const isArrayEqual = <T>(a: T[], b: T[]): boolean => {
  if (a.length !== b.length) {
    return false;
  }

  return isEmpty(xorWith(a, b, isEqual));
};
